import { Building2, CalendarClock, LineChart, ReceiptText, UserRoundCheck, type LucideIcon } from 'lucide-react';

/** A Cost sub-nav entry. The empty slug is the Cost index (`/cost`). */
export interface SpendCostNavItem {
    slug: string;
    label: string;
    icon: LucideIcon;
}

/** The Cost section rail: the by-provider overview, the by-department breakdown, the month-end forecast, per-user license fit, and the spend trend. Drill-ins (provider/model records, department people) are reached by clicking rows, not the rail. */
export const SPEND_COST_NAV: SpendCostNavItem[] = [
    { slug: '', label: 'Overview', icon: ReceiptText },
    { slug: 'by-department', label: 'By Department', icon: Building2 },
    { slug: 'trend', label: 'Cost Trend', icon: LineChart },
    { slug: 'forecast', label: 'Forecast', icon: CalendarClock },
    { slug: 'license-fit', label: 'License Fit', icon: UserRoundCheck },
];
